import React from "react";
import { MessageSquareQuote, HelpCircle } from "lucide-react";
import { offerScript, QUESTIONS } from "./offerTips";

export function OfferScript({ offer, list, prefix }) {
  if (!offer) return null;
  return (
    <details className="group rounded-lg border border-primary/30 bg-primary/5 px-4 py-2.5" data-testid={`${prefix}-script`}>
      <summary className="text-sm font-semibold flex items-center gap-2 cursor-pointer list-none" data-testid={`${prefix}-script-toggle`}><MessageSquareQuote className="w-4 h-4 text-primary" /> Cosa dire al cliente <span className="text-xs font-normal text-muted-foreground group-open:hidden">· apri lo script</span></summary>
      <div className="space-y-3 mt-2">
      <div className="space-y-1.5 text-sm">{offerScript(offer, list).map((l, i) => <p key={i} data-testid={`${prefix}-script-line-${i}`}>{l}</p>)}</div>
      <div>
        <p className="text-xs font-medium flex items-center gap-1.5 text-muted-foreground"><HelpCircle className="w-3.5 h-3.5" /> Domande per capire se è l'offerta giusta</p>
        <ul className="list-disc pl-5 text-xs text-muted-foreground mt-1 space-y-0.5">{QUESTIONS.map((q) => <li key={q}>{q}</li>)}</ul>
      </div>
      <p className="text-[11px] text-muted-foreground">Spese stimate da Venergia su un consumo tipo: non sono una promessa al cliente.</p>
      </div>
    </details>
  );
}
